import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

export class CameraController {
    constructor(camera, renderer) {
        this.camera = camera;
        this.renderer = renderer;
        this.controls = null;
        
        // Preset positions
        this.presets = {
            top: {
                position: new THREE.Vector3(0, 50, 0),
                target: new THREE.Vector3(0, 0, 0)
            },
            side: {
                position: new THREE.Vector3(50, 0, 0),
                target: new THREE.Vector3(0, 0, 0)
            },
            closeup: {
                position: new THREE.Vector3(0, 0, 15),
                target: new THREE.Vector3(0, 0, 0)
            },
            diagonal: {
                position: new THREE.Vector3(30, 30, 30),
                target: new THREE.Vector3(0, 0, 0)
            }
        };
        
        this.init();
    }

    init() {
        // Create OrbitControls
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.05;
        this.controls.minDistance = 5;
        this.controls.maxDistance = 200;
        this.controls.maxPolarAngle = Math.PI; // Allow full rotation
        this.controls.enablePan = true;
        this.controls.target.set(0, 0, 0);
        this.controls.update();
    }

    update() {
        if (this.controls) {
            this.controls.update();
        }
    }

    setPreset(presetName) {
        const preset = this.presets[presetName];
        if (!preset) return;
        
        // Smoothly transition to preset
        const startPos = this.camera.position.clone();
        const startTarget = this.controls.target.clone();
        const duration = 1000; // ms
        const startTime = Date.now();
        
        const animate = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const ease = 1 - Math.pow(1 - progress, 3); // Ease out cubic
            
            this.camera.position.lerpVectors(startPos, preset.position, ease);
            this.controls.target.lerpVectors(startTarget, preset.target, ease);
            this.controls.update();
            
            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };
        
        animate();
    }

    getControls() {
        return this.controls;
    }

    setEnabled(enabled) {
        if (this.controls) {
            this.controls.enabled = enabled;
        }
    }

    setTarget(target) {
        if (this.controls) {
            this.controls.target.copy(target);
            this.controls.update();
        }
    }

    dispose() {
        if (this.controls) {
            this.controls.dispose();
        }
    }
}
